import { useAdminAccess } from '../../hooks/useAdminAccess';

export default function AdminDashboard() {
  const { isSuperAdmin, groups } = useAdminAccess();

  return (
    <div className="admin-dashboard">
      <div className="admin-page-header">
        <h2>Dashboard</h2>
        <p className="admin-page-subtitle">Welcome to the ArchiveAbyss Admin Portal</p>
      </div>

      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="admin-stat-icon">🏢</div>
          <div className="admin-stat-content">
            <div className="admin-stat-value">-</div>
            <div className="admin-stat-label">Tenants</div>
          </div>
        </div>

        <div className="admin-stat-card">
          <div className="admin-stat-icon">👥</div>
          <div className="admin-stat-content">
            <div className="admin-stat-value">-</div>
            <div className="admin-stat-label">Users</div>
          </div>
        </div>

        <div className="admin-stat-card">
          <div className="admin-stat-icon">💬</div>
          <div className="admin-stat-content">
            <div className="admin-stat-value">-</div>
            <div className="admin-stat-label">Messages</div>
          </div>
        </div>

        <div className="admin-stat-card">
          <div className="admin-stat-icon">🔐</div>
          <div className="admin-stat-content">
            <div className="admin-stat-value">-</div>
            <div className="admin-stat-label">Permissions</div>
          </div>
        </div>
      </div>

      <div className="admin-info-card">
        <h3>Your Access Level</h3>
        <div className="admin-access-info">
          <div className="admin-badge-row">
            <span className={`admin-badge ${isSuperAdmin ? 'admin-badge-primary' : 'admin-badge-secondary'}`}>
              {isSuperAdmin ? 'Super Admin' : 'Tenant Admin'}
            </span>
          </div>
          <p className="admin-access-description">
            {isSuperAdmin
              ? 'You have full system access. You can manage tenants, users, and all settings.'
              : 'You can manage users and permissions within your assigned tenant(s).'}
          </p>
          {groups.length > 0 && (
            <div className="admin-groups">
              <span className="admin-groups-label">Groups:</span>
              {groups.map(g => (
                <span key={g} className="admin-group-tag">{g}</span>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="admin-quick-actions">
        <h3>Quick Actions</h3>
        <div className="admin-action-grid">
          {isSuperAdmin && (
            <a href="/admin/tenants" className="admin-action-card">
              <span className="admin-action-icon">➕</span>
              <span>Create Tenant</span>
            </a>
          )}
          <a href="/admin/tenants" className="admin-action-card">
            <span className="admin-action-icon">👤</span>
            <span>Manage Users</span>
          </a>
          <a href="/admin/audit-logs" className="admin-action-card">
            <span className="admin-action-icon">📋</span>
            <span>View Audit Logs</span>
          </a>
        </div>
      </div>
    </div>
  );
}
